import React, { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Row } from "reactstrap";
import LocationSearch from "../../helpers/Common/LocationSearch";
import SearchableDropdown from "../../helpers/Common/SearchableDropdown";
import { getDropdownOptions } from "../../helpers/common";
import { getCategories } from "../../api/categories";

const CandidateSearchOptions = () => {
  const [query, setQuery] = useState("");
  const [location, setLocation] = useState("");
  const [category, setCategory] = useState("");
  const [designation, setDesignation] = useState("");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setLoading(true);

    getCategories()
      .then((res) => {
        const arrayData = res?.data?.data || [];
        setCategories(arrayData);
      })
      .catch((err) => {
        console.error("FULL ERROR:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let queryVal = searchParams.get("q");
    let designationVal = searchParams.get("designation");
    let locationVal = searchParams.get("location");
    let categoryVal = searchParams.get("category");

    if (designationVal) {
      setDesignation(designationVal);
    }
    if (queryVal) {
      setQuery(queryVal);
    }
    if (locationVal) {
      setLocation(locationVal);
    }
    if (categoryVal) {
      setCategory(categoryVal);
    }
  }, [searchParams]);

  const onSubmit = (e) => {
    e.preventDefault();

    let params = [];
    let industry = searchParams.get("Industry");
    let salaryRange = searchParams.get("salary_range");
    let workExperience = searchParams.get("work_experience");

    if (designation) {
      params.push(`designation=${encodeURIComponent(designation)}`);
    }
    if (location) {
      params.push(`location=${location}`);
    }
    if (category) {
      params.push(`category=${category}`);
    }
    if (industry) {
      params.push(`Industry=${industry}`);
    }
    if (salaryRange) {
      params.push(`salary_range=${salaryRange}`);
    }
    if (workExperience) {
      params.push(`work_experience=${workExperience}`);
    }

    const newParams = `/candidates?${params?.join("&")}`;
    navigate(newParams);
  };

  return (
    <React.Fragment>
      <div className="job-list-header mb-4">
        <Form onSubmit={onSubmit}>
          {/* 🟢 Removed 'flex-nowrap' and added responsive grid gutters */}
          <Row className="g-3 align-items-center">
            {/* Designation Field */}
            <Col xs={12} md={5} lg={5}>
              <div className="filler-job-form search-input">
                <SearchableDropdown
                  options={getDropdownOptions(categories, {
                    label: "name",
                    value: "name",
                  })}
                  value={designation}
                  onChange={setDesignation}
                  placeholder="Designation"
                  leftIcon={<i className="uil uil-briefcase-alt"></i>}
                  isCreatable={true}
                  sortOptionsAlphabetically
                  isLoading={loading}
                />
              </div>
            </Col>

            {/* Location Field */}
            <Col xs={12} md={4} lg={4}>
              <div className="filler-job-form search-input-box">
                <LocationSearch
                  setLocation={setLocation}
                  location={location}
                />
              </div>
            </Col>

            {/* Submit Button */}
            <Col xs={12} md={3} lg={3}>
              <button
                className="btn btn-primary submit-btn w-100"
                type="submit"
              >
                <i className="uil uil-search me-1"></i> Search
              </button>
            </Col>
          </Row>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default CandidateSearchOptions;
